export default "__VITE_ASSET__CxFpLz5R__"